import { useAuth } from '@/store/useAuth';
import { useUpdateUserData } from '@/hooks/use-update-profile';
import { generatePath, useNavigate } from 'react-router';
import { routesApp } from '@/constans/routes';
import React, { useCallback, useEffect } from 'react';
import { UploadPhotoRegistartionForm } from './components/upload-photo-registartion-form';
import 'react-toastify/dist/ReactToastify.css';
import { NameRegistartionForm } from './components/name-registartion-form';
import { DateRegistartionForm } from './components/date-registartion-form';
import {
    SettingInfoRegistrationForm
} from '@/components/form-registration-v3/components/setting-info-registartion-form';
import { TargetInfoRegistrationForm } from '@/components/form-registration-v3/components/target-info-registartion-form';
import {
    DirectionInfoRegistrationForm
} from '@/components/form-registration-v3/components/direction-info-registartion-form';
import { AboutAndTravelPlansRegistartionForm } from './components/about-and-travel-plans-registartion-form';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
interface Props {
    step?: string;
    isLoadingOncePage?: boolean;
    onChangeIsLoadingPage?: (bol: boolean) => void;
}

export const FormRegistration: React.FC<Props> = ({ step, isLoadingOncePage, onChangeIsLoadingPage }) => {
    const userData = useAuth((state) => state.getUser());
    const { mutateAsync: updateUserData } = useUpdateUserData();
    const handleUpdateUserData = async (data: any) => {
        if (!userData) return;
        await updateUserData(data);
    };

    const navigateToNextStep = useNavigate();
    const nextStep = useCallback(
        (step: string) => navigateToNextStep(generatePath(routesApp.registrationV3, { stepNumer: step })),
        [navigateToNextStep],
    );
    useEffect(() => {
        if (userData && isLoadingOncePage) {
            onChangeIsLoadingPage?.(false);
            // Если пользователь уже отмечен как завершенный - не душим его повторным проходом по регистрации
            // кидаем сразу в ленту
            if (userData.state === 'complete') return navigateToNextStep(generatePath(routesApp.browse));

            // Проверяем, на каком шаге нужно продолжить регистрацию
            if (!userData?.public_name) {
                nextStep('1');
                return;
            } else if (!userData?.dob) {
                nextStep('2');
                return;
            } else if (!userData?.about_me || !userData?.travel_plans) {
                nextStep('3');
                return;
            } else if (!userData?.gender || !userData?.looks_for) {
                nextStep('4');
                return;
            } else if (!userData?.purpose) {
                nextStep('5');
                return;
            } else if (!userData?.regions?.length) {
                nextStep('6');
                return;
            } else if (!userData?.photos.length) {
                nextStep('7');
                return;
            } else {
                nextStep('7');
            }
        }
    }, []);

    switch (step) {
        case '1':
            return (
                <NameRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('2')} />
            );
        case '2':
            return (
                <DateRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('3')} />
            );
        case '3':
            return (
                <AboutAndTravelPlansRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('4')} />
            );
        case '4':
            return (
                <SettingInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('5')} />
            );
        case '5':
            return (
                <TargetInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('6')} />
            );
        case '6':
            return (
                <>
                    <DirectionInfoRegistrationForm
                        userData={userData}
                        onUpdateUserData={handleUpdateUserData}
                        nextStep={() => nextStep('7')}
                    />
                </>
            );
        case '7':
            return (
                <UploadPhotoRegistartionForm
                    userData={userData}
                    nextStep={() => {
                        callYaMetrika('complete_registration3');
                        eventsApi.updateUserEvent('complete_registration3');
                        navigateToNextStep(routesApp.browse)
                    }} />
            );
        default:
            return <>Error 404</>;
    }
};
